<template>
  <Breadcrumbs
      title="Promotion Approval"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Promotions', path: '/promotions' },
      { label: 'Promotion Approval', path: '/promotion_approval' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <PromotionApprovalList />
    </div>
  </div>
</template>

<script>
import PromotionApprovalList from './promotion_approval_list.vue'
export default {
  name: 'indexList',
  components: {
    PromotionApprovalList: PromotionApprovalList,
  },
}
</script>